<template>
  <b-overlay :show="loading">
    <div class="d-flex justify-content-center align-items-center">
      <!--      <CheckPermission permission="ED018">-->
      <!--        <b-button-->
      <!--          data-cy="details"-->
      <!--          v-b-modal="`modal-details-${file.idAprobacion}`"-->
      <!--          variant="secondary"-->
      <!--          class="btn-icon rounded-circle p-3"-->
      <!--          size="sm"-->
      <!--          v-on:click="onOptionGetGeneralDetailsFile(file)"-->
      <!--        >-->
      <!--          <feather-icon icon="SearchIcon" />-->
      <!--        </b-button>-->
      <!--      </CheckPermission>-->
      <div v-tooltip="'Desplegar acciones'">
        <b-dropdown
          variant="link"
          no-caret
          right
        >
          <template #button-content>
            <feather-icon
              data-cy="gear-button"
              width="24px"
              height="24px"
              icon="SettingsIcon"
              class="align-middle text-body"
            />
          </template>
          <CheckPermission permission="WBF102">
            <b-dropdown-item
              data-cy="binnacle"
              v-on:click="onOptionBinnacleFile()"
            >
              <vs-icon icon="list" />
              Bitácora
            </b-dropdown-item>
          </CheckPermission>
          <CheckPermission permission="WBF103">
            <b-dropdown-item
              data-cy="preview"
              v-on:click="previewBillin()"
            >
              <vs-icon icon="visibility" />
              Previsualizar
            </b-dropdown-item>
          </CheckPermission>
          <CheckPermission permission="WBF104">
            <b-dropdown-item
              data-cy="edit"
              v-on:click="editBilling()"
            >
              <vs-icon icon="edit" />
              Editar
            </b-dropdown-item>
          </CheckPermission>
        </b-dropdown>
        <span />
      </div>
    </div>
  </b-overlay>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import CheckPermission from '@/febos/global/usuario/components/CheckPermission';

export default {
  components: { CheckPermission },
  props: [
    'file'
  ],
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapGetters('Empresas', [
      'company'
    ]),
    ...mapGetters('Usuario', [
      'currentUserId',
      'hasPermission'
    ])
  },
  methods: {
    ...mapActions('Modals', [
      'showModals'
    ]),
    ...mapActions('Billing', [
      'openEditBilling',
      'openPreviewBilling',
      'getBinnacle',
      'selectFile'
    ]),
    editBilling() {
      this.openEditBilling({ id: this.file.id });
    },
    onOptionBinnacleFile() {
      this.selectFile(this.file);
      this.getBinnacle({
        febosId: this.file.id,
        filas: 200,
        pagina: 1
      });
      this.showModals('binnacle');
    },
    previewBillin() {
      this.selectFile(this.file);
      this.$bvToast.toast(
        'Estamos generando la previsualización',
        {
          title: '¡Oye!',
          variant: 'warning',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 5000
        }
      );
      this.openPreviewBilling({
        id: this.file.id
      });
    }
  }
};

</script>
